import * as PIXI from 'pixi.js';
import { Assets, Container, Sprite } from "pixi.js"
import { containers, gameAssets } from "../gameUI"
import { scaleFactor, tweenFade } from "../utility"
import { playDisable, playMinus, playPlus, playPopTabChange, playPopUpClose } from '../soundManager';
import { gameData, networkData } from '../data';
import gsap from 'gsap';
import { betHistory } from '../networkService';

let settingsBtnGraphic
let betHistoryGraphic;
let pageContainer = [];
let pageMarkers = [];
let isPopupOpen = false
let currentPage = 0;
let totalPages = networkData.isJackpot ? 4 : 3;

function showPage(pageNumber, flag) {
    if (pageNumber < 0 || pageNumber >= totalPages) {
        playDisable(true);
        return;
    }
    
    if(pageNumber == totalPages - 1 && networkData.showAutoTurbo){
        gameAssets.tutArrow.visible = true;
    } else {
        gameAssets.tutArrow.visible = false;
    }

    if (flag) playMinus(true);
    else playPlus(true);

    console.log("ewgergregre", pageContainer[currentPage]);    

    pageMarkers[currentPage].visible = false;
    currentPage = pageNumber; // Fix: Prevents cycling back to 0
    gameAssets.tutorialBase.removeChildren();
    gameAssets.tutorialBase.sortableChildren = true;
    gameAssets.tutorialBase.addChild(pageContainer[currentPage], gameAssets.tutorialCloseBtn, settingsBtnGraphic, containers.paginationContainer, betHistoryGraphic, gameAssets.tutArrow);
    pageMarkers[currentPage].visible = true;
}

function createPaginationControls() {
    containers.paginationContainer = new PIXI.Container();
    gameAssets.tutorialBase.addChild(containers.paginationContainer);

    const leftNormal = new Sprite(Assets.get('left_b_normal'));
    leftNormal.anchor.set(0.5);
    leftNormal.position.set(0, 10);

    const tutorialNormal1 = new Sprite(Assets.get('tutorialNormal'));
    tutorialNormal1.anchor.set(0.5);
    tutorialNormal1.position.set(130, 10);

    const tutorialNormal2 = new Sprite(Assets.get('tutorialNormal'));
    tutorialNormal2.anchor.set(0.5);
    tutorialNormal2.position.set(260, 10);

    const tutorialNormal3 = new Sprite(Assets.get('tutorialNormal'));
    tutorialNormal3.anchor.set(0.5);
    tutorialNormal3.position.set(390, 10);

    const tutorialNormal4 = new Sprite(Assets.get('tutorialNormal'));
    tutorialNormal4.anchor.set(0.5);
    const pos = networkData.isJackpot ? 520 : 390;
    tutorialNormal4.position.set(pos, 10);

    const tutorialNormal5 = new Sprite(Assets.get('tutorialNormal'));
    tutorialNormal5.anchor.set(0.5);
    const pos1 = networkData.isJackpot ? 640 : 505;
    tutorialNormal5.position.set(pos1, 10);

    const tutorialSelected1 = new Sprite(Assets.get('tutorialSelected'));
    tutorialSelected1.anchor.set(0.5);
    tutorialSelected1.position.set(0, 0);
    tutorialSelected1.visible = false;
    tutorialNormal1.addChild(tutorialSelected1);

    const tutorialSelected2 = new Sprite(Assets.get('tutorialSelected'));
    tutorialSelected2.anchor.set(0.5);
    tutorialSelected2.position.set(0, 0);
    tutorialSelected2.visible = false;
    tutorialNormal2.addChild(tutorialSelected2);

    const tutorialSelected3 = new Sprite(Assets.get('tutorialSelected'));
    tutorialSelected3.anchor.set(0.5);
    tutorialSelected3.position.set(0, 0);
    tutorialSelected3.visible = false;
    tutorialNormal3.addChild(tutorialSelected3);

    const tutorialSelected4 = new Sprite(Assets.get('tutorialSelected'));
    tutorialSelected4.anchor.set(0.5);
    tutorialSelected4.position.set(0, 0);
    tutorialSelected4.visible = false;
    tutorialNormal4.addChild(tutorialSelected4);

    const tutorialSelected5 = new Sprite(Assets.get('tutorialSelected'));
    tutorialSelected5.anchor.set(0.5);
    tutorialSelected5.position.set(0, 0);
    tutorialSelected5.visible = false;
    tutorialNormal5.addChild(tutorialSelected5);

    const rightNormal = new Sprite(Assets.get('right_b_normal'));
    rightNormal.anchor.set(0.5);
    const rigPos = networkData.isJackpot ? 765 : 630
    rightNormal.position.set(rigPos, 10); 

    if(networkData.isJackpot){
        containers.paginationContainer.addChild(
            leftNormal,
            tutorialNormal1, tutorialNormal2,
            tutorialNormal3 ,
            tutorialNormal4,
            tutorialNormal5,
            rightNormal
        );
    } else {
        containers.paginationContainer.addChild(
            leftNormal,
            tutorialNormal1, tutorialNormal2,
            tutorialNormal4,
            tutorialNormal5,
            rightNormal
        );
    }
    containers.paginationContainer.pivot.set(0.5);
    const pagePos = networkData.isJackpot ?-610 : -505
    containers.paginationContainer.position.set(pagePos, 1350);
    containers.paginationContainer.scale.set(1.6)

    if(networkData.isJackpot){
        pageMarkers = [
            tutorialSelected1, 
            tutorialSelected2, 
            tutorialSelected3,
            tutorialSelected4,
            tutorialSelected5
        ];
    } else {
        pageMarkers = [
            tutorialSelected1, 
            tutorialSelected2, 
            tutorialSelected4,
            tutorialSelected5
        ];
    }
    leftNormal.interactive = true;
    leftNormal.buttonMode = true;
    leftNormal.cursor = 'pointer';
    rightNormal.interactive = true;
    rightNormal.buttonMode = true;
    rightNormal.cursor = 'pointer';

    leftNormal.on('pointerdown', (event) => {
        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
            showPage(currentPage - 1, true);
        }
    });
    leftNormal.on('pointerover', () => { leftNormal.texture = Assets.get('left_b_selected'); });
    leftNormal.on('pointerout', () => { leftNormal.texture = Assets.get('left_b_normal'); });

    rightNormal.on('pointerdown', (event) => {
        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
            showPage(currentPage + 1, false);
        }
    });
    rightNormal.on('pointerover', () => { rightNormal.texture = Assets.get('right_b_selected'); });
    rightNormal.on('pointerout', () => { rightNormal.texture = Assets.get('right_b_normal'); });
}


export const setupTutorial = (language = "en") => {    
    if (gameAssets.tutorialBase) {
        gameAssets.tutorialBase.removeChildren();
    } else {
        gameAssets.tutorialBase = new Sprite(Assets.get("tutorial"));
    }
    if (!containers.tutorialContainer) containers.tutorialContainer = new Container()
    containers.popupContainer.addChild(containers.tutorialContainer)
    containers.tutorialContainer.visible = false
    gameAssets.tutorialBase.anchor.set(0.5)
    containers.tutorialContainer.addChild(gameAssets.tutorialBase)

    const width = gameAssets.tutorialBase.width
    const height = gameAssets.tutorialBase.height
    gameAssets.tutorialBase.resize = (w, h) => {
        const expandFactor = 0.85
        const scale = scaleFactor(gameAssets.gameScreen.width, width)
        gameAssets.tutorialBase.x = w * 0.5
        gameAssets.tutorialBase.y = h * 0.44
        gameAssets.tutorialBase.width = width * scale * expandFactor
        gameAssets.tutorialBase.height = height * scale * expandFactor
    }

    gameAssets.tutArrow = new Sprite(Assets.get("arrow_down"));
    gameAssets.tutArrow.anchor.set(0.5);
    gameAssets.tutArrow.y = 1220
    gameAssets.tutArrow.scale.set(2.8);
    gameAssets.tutArrow.interactive = true;
    gameAssets.tutArrow.cursor = 'pointer'
    gameAssets.tutArrow.visible = false;

    gameAssets.tutArrow.on('pointerdown', ()=>{
        gameAssets.tutArrow.visible = false;
        gameData.tutScroll = true;
    })

    gsap.timeline({ repeat: -1, yoyo: true }) 
        .to(gameAssets.tutArrow, {
            pixi: {
                scale: 3.5
            },
            duration: 0.3,
            ease: "power1.inOut", 
    });

    gameAssets.tutorialBase.addChild(gameAssets.tutArrow)


    settingsBtnGraphic = new PIXI.Graphics();
    containers.settingsButtonContainer.addChild(settingsBtnGraphic)
    settingsBtnGraphic.beginFill(0x552155, 1);
    settingsBtnGraphic.drawRect(-730, -1150, 550, 135);
    settingsBtnGraphic.x = -155
    settingsBtnGraphic.y = -60
    settingsBtnGraphic.endFill();
    settingsBtnGraphic.alpha = 0.01
    settingsBtnGraphic.interactive = true
    settingsBtnGraphic.cursor = 'pointer'
    settingsBtnGraphic.on('pointerdown', (event) => {
        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
            playPopTabChange(true)
            containers.settingsContainer.visible = true
            containers.tutorialContainer.visible = false
        }

    })

    betHistoryGraphic = new PIXI.Graphics();
    containers.settingsButtonContainer.addChild(betHistoryGraphic);
    betHistoryGraphic.beginFill(0x000000, 1);
    betHistoryGraphic.drawRoundedRect(-730, -1150, 580, 140, 0); // last param is corner radius
    betHistoryGraphic.x = 1050;
    betHistoryGraphic.y = -65;
    betHistoryGraphic.endFill();
    betHistoryGraphic.alpha = 0.01;
    betHistoryGraphic.interactive = true
    betHistoryGraphic.cursor = 'pointer';
    betHistoryGraphic.on('pointerdown', (event)=>{
        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
            playPopTabChange(true)
            containers.settingsContainer.visible = false
            containers.tutorialContainer.visible = false;
            containers.betHistoryContainer.visible = true;
            betHistory()
        }   
    })

    gameAssets.tutorialBase.addChild(containers.settingsButtonContainer)

    if (!gameAssets.tutorialCloseBtn) gameAssets.tutorialCloseBtn = new Sprite(Assets.get('close_b_normal'))
    gameAssets.tutorialCloseBtn.anchor.set(0.5)
    gameAssets.tutorialBase.addChild(gameAssets.tutorialCloseBtn)
    gameAssets.tutorialCloseBtn.x = 770
    gameAssets.tutorialCloseBtn.y = -860
    gameAssets.tutorialCloseBtn.interactive = true
    gameAssets.tutorialCloseBtn.buttonMode = true
    gameAssets.tutorialCloseBtn.zIndex = 100;
    gameAssets.tutorialCloseBtn.scale.set(1.5)
    gameAssets.tutorialCloseBtn.cursor = 'pointer'
    gameAssets.tutorialCloseBtn.on('pointerover', () => { gameAssets.tutorialCloseBtn.texture = Assets.get('close_b_selected') })
    gameAssets.tutorialCloseBtn.on('pointerout', () => { gameAssets.tutorialCloseBtn.texture = Assets.get('close_b_normal') })
    gameAssets.tutorialCloseBtn.on('pointerdown', (event) => {
        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
            hidePopup()
        }
    })

    const suffix = language === "tl" ? "_tag" : "_en";
    if(suffix == '_en'){
        gameData.stopPos = -1000;
        gameData.dragPos = -990;
    } else {
        gameData.stopPos = -1135
        gameData.dragPos = -1130
    }

    gameAssets.page1Container = new PIXI.Container();
    gameAssets.p1Image = new Sprite(Assets.get(`tutorial1${suffix}`));
    gameAssets.p1Image.anchor.set(0.5);
    gameAssets.p1Image.x = language == 'en' ? 0 : 0;
    gameAssets.p1Image.y = language == 'en' ? 190 : 235;
    gameAssets.page1Container.addChild(gameAssets.p1Image);
    const p1Scale = language == 'en' ? 3.5 : 3.3
    gameAssets.p1Image.scale.set(p1Scale);

    gameAssets.page2Container = new PIXI.Container();
    gameAssets.p2_image = new Sprite(Assets.get(`tutorial2${suffix}`));
    gameAssets.p2_image.anchor.set(0.5);
    const p2Pos = language == 'en' ? 260 : 150
    gameAssets.p2_image.y = p2Pos;
    gameAssets.p2_image.x = 40
    gameAssets.page2Container.addChild(gameAssets.p2_image);
    gameAssets.p2_image.scale.set(3.5);

    gameAssets.page3Container = new PIXI.Container();
    gameAssets.p3_image = new Sprite(Assets.get(`tutorial3${suffix}`));
    gameAssets.p3_image.anchor.set(0.5);
    gameAssets.p3_image.y = language == 'en' ? 110 : 80;
    gameAssets.page3Container.addChild(gameAssets.p3_image);
    gameAssets.page3Container.scale.set(3);

    gameAssets.page5Container = new PIXI.Container();
    gameAssets.p5_image = new Sprite(Assets.get(`tutorial5${suffix}`));
    gameAssets.p5_image.anchor.set(0.5);
    gameAssets.p5_image.y = 40;
    gameAssets.page5Container.addChild(gameAssets.p5_image);
    const scale5 = language == 'en' ? 3.7 : 2.85
    gameAssets.page5Container.scale.set(scale5);

    if(networkData.showAutoTurbo){

        gameAssets.page4Container = new PIXI.Container();
        gameAssets.p4_image = new Sprite(Assets.get(`tutorial4${suffix}`));
        gameAssets.p4_image.anchor.set(0.5);
        gameAssets.p4_image.y = language == 'en' ? 1130 : 1255;
        gameAssets.p4_image.x = language == 'en' ? -10 : 5
    
        gameAssets.maskGraphic = new PIXI.Graphics();
        gameAssets.maskGraphic.beginFill(0x000000);
        gameAssets.maskGraphic.drawRect(-300, -300, 600, 690);
        gameAssets.maskGraphic.endFill();
        gameAssets.page4Container.mask = gameAssets.maskGraphic
    
        gameAssets.page4Container.addChild(gameAssets.p4_image, gameAssets.maskGraphic);
    
        const p4Scale = 3 ;
        gameAssets.page4Container.scale.set(p4Scale);
    
        let isDragging = false;
        let startY = 0;
    
        gameAssets.p4_image.interactive = true;
        gameAssets.p4_image.buttonMode = true;
        gameAssets.p4_image.cursor = 'grab';
    
        gameAssets.p4_image.on('pointerdown', (event) => {
            isDragging = true;
            startY = event.data.global.y - gameAssets.p4_image.y;
            gameAssets.p4_image.cursor = 'grabbing';
        });
    
        gameAssets.p4_image.on('pointermove', (event) => {
            if (isDragging) {
                const targetY = event.data.global.y - startY;
                const dragSpeed = 0.03; // 🐢 Lower = slower scroll
                const smoothedY = gameAssets.p4_image.y + (targetY - gameAssets.p4_image.y) * dragSpeed;
    
                const minY = language == 'en' ? -1000 : -1140;
                const maxY = language == 'en' ? 1130 : 1255;

                gameData.tutScroll = false;
                if(gameAssets.p4_image.y < gameData.dragPos){
                    gameAssets.tutArrow.visible = false;
                } else {
                    gameAssets.tutArrow.visible = true;
                }
    
                gameAssets.p4_image.y = Math.min(Math.max(smoothedY, minY), maxY);
            }
        });
    
        gameAssets.p4_image.on('pointerup', () => {
            isDragging = false;
            gameAssets.p4_image.cursor = 'grab';
        });
    
        gameAssets.p4_image.on('pointerupoutside', () => {
            isDragging = false;
            gameAssets.p4_image.cursor = 'grab';
        });
    } else {
        gameAssets.page4Container = new PIXI.Container();
        gameAssets.p4_image = new Sprite(Assets.get(`tutorial4${suffix}_without_auto`));
        gameAssets.p4_image.anchor.set(0.5);
        const scale = language == 'en' ? 2.45 : 2.3;
        gameAssets.p4_image.scale.set(scale)
        gameAssets.p4_image.y = language == 'en' ? 140 : 150;
        gameAssets.p4_image.x = language == 'en' ? 20 : 26

        gameAssets.page4Container.addChild(gameAssets.p4_image);
    }


    pageContainer = networkData.isJackpot
        ? [gameAssets.page1Container, gameAssets.page2Container, gameAssets.page3Container, gameAssets.page5Container, gameAssets.page4Container]
        : [gameAssets.page1Container, gameAssets.page2Container, gameAssets.page5Container, gameAssets.page4Container];

    totalPages = pageContainer.length;

createPaginationControls();
gameAssets.tutorialBase.addChild(pageContainer[currentPage]);
pageMarkers[currentPage].visible = true;



}

export const setupTutScroll = (delta) => {
    gameAssets.p4_image.y = gameAssets.p4_image.y - 2 * delta;  
    console.log("egr4tg", gameData.stopPos, gameAssets.p4_image.y);
      

    if(gameAssets.p4_image.y < gameData.stopPos){
        gameData.tutScroll = false;
    }
}


export const hidePopup = () => {
    setIsPopupOpen(false)
    playPopUpClose(true)
    gameData.isPopupOpen = false;
    tweenFade(gameAssets.dimmer, false, 0.3)
    tweenFade(containers.popupContainer, false, 0.3, ()=>{
        containers.popupContainer.visible = false
        gameAssets.dimmer.visible = false;
        containers.settingsContainer.visible = true
        containers.tutorialContainer.visible = false
        containers.betHistoryContainer.visible = false;
    })
    containers.popupContainer.interactiveChildren = false
    gameAssets.footer.visible = true;
}

export const setIsPopupOpen = (isOpen) => {
    isPopupOpen = isOpen
}

export const getIsPopupOpen = () => isPopupOpen